/**
 * Pre-Pack section layout. Labor clock-in runs on the shipment carton workspace (`PrePackCartonPage`)
 * and the transfer packing workspace (`PrePackTransferPage`); the queue route is list-only.
 */

import { Outlet } from "react-router-dom";

export function PrePackLayout() {
  return <Outlet />;
}
